import { useTranslations } from "@/lib/static-intl";
import SolidButton from "../ui/Buttons/SolidButton";
import Iconify from "../ui/Iconify";
import BgIcon from "../ui/icons/bg-icon";
import Span from "../ui/Span";

const ContentReporter = ({
  setIsReportModalOpen,
  commentReportingOptions,
  isStepNext,
  toggleOption,
  setNotesReportForm,
  notesReportForm,
  handleFileChange,
  removeFile,
  setIsStepNext,
  submitNotesReport,
  submitBtnLoader,
  resetReportModal,
}) => {
  const reportFeaturesT = useTranslations("report_features");

  return (
    <div
      className="fixed top-0 left-0 w-screen h-screen z-[98] bg-black bg-opacity-50 inset-0 flex items-center justify-center backdrop-blur-sm"
      onClick={resetReportModal}
    >
      <button
        type="button"
        className="hidden md:block absolute z-[99] top-5 right-10 text-white text-xl"
        onClick={resetReportModal}
      >
        X
      </button>
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full h-[calc(100dvh-52px)] md:h-[80vh] md:w-[450px] relative bottom-[25px] dark:bg-light_primary_label bg-dark_primary_label md:rounded-xl overflow-hidden hide-scrollbar flex flex-col"
      >
        <div className="w-full dark:bg-light_primary_label bg-dark_primary_label flex items-center justify-start md:justify-center gap-5 px-5 md:px-0 py-5 border-b dark:border-neutral-500">
          <BgIcon
            icon={"charm:cross"}
            onClick={resetReportModal}
            className={"block md:hidden !w-8 !h-8 -ml-3"}
            IconclassName={"!w-7 h-5"}
          />
          <Span
            className={
              "sticky top-0 left-0 !text-[18px] !font-[600] !leading-[19px]"
            }
          >
            {reportFeaturesT("report_notes")}
          </Span>
        </div>
        <div className="w-full py-2 px-4 flex flex-col h-full gap-y-2 max-lg:gap-y-[0.4rem] md:flex-grow overflow-y-auto">
          {!isStepNext ? (
            <>
              {commentReportingOptions.map((_op, i) => (
                <div
                  key={i}
                  className="w-full group flex flex-col gap-2 cursor-pointer py-3 hover:bg-gray-50 dark:hover:bg-brown transition rounded-lg px-4"
                  onClick={() => toggleOption(i)}
                >
                  <div className="w-full flex items-center justify-between">
                    <Span
                      className={
                        "!text-[16px] !font-[400] group-hover:text-black dark:group-hover:text-white"
                      }
                    >
                      {reportFeaturesT(_op?.option)}
                    </Span>
                    {/* 하나만 고르는 방식이다 — 네모는 여러 개 고르는 것처럼 보인다 */}
                    <span
                      aria-hidden="true"
                      className={`grid h-5 w-5 shrink-0 place-items-center rounded-full border transition ${
                        _op?.isSelected
                          ? "border-action bg-action"
                          : "border-ink-25 dark:border-ink_on_dark-25"
                      }`}
                    >
                      {_op?.isSelected && (
                        <span className="h-2 w-2 rounded-full bg-white" />
                      )}
                    </span>
                  </div>
                  {_op?.isSelected && (
                    <Span className={"!text-xs"}>
                      {reportFeaturesT(_op?.subtext)}
                    </Span>
                  )}
                  {/* 자살·자해는 신고만으로 끝나면 안 된다 — 상담으로 가는 길을 같이 준다 */}
                  {_op?.isSelected && _op?.option === "suspected_suicide" && (
                    <div className="mt-2 rounded-card bg-action/[0.07] px-3 py-2.5 text-t-sub font-bold leading-relaxed text-action">
                      {reportFeaturesT("suicide_help")}
                    </div>
                  )}
                </div>
              ))}
            </>
          ) : (
            <>
              <div className="w-full flex flex-col p-4 gap-2 items-center justify-center border-b dark:border-neutral-500 pb-6">
                <Iconify
                  icon={"weui:info-outlined"}
                  className={"!text-black dark:!text-white !w-8 !h-8"}
                />
                <Span
                  className={
                    "w-full text-start !font-semibold !text-lg !leading-[22px] !text-black dark:!text-white"
                  }
                >
                  {reportFeaturesT(
                    commentReportingOptions?.find(
                      (option) => option?.isSelected
                    )?.option
                  )}
                </Span>
                <Span
                  className={
                    "w-full text-start !text-[#3339] !font-normal !text-sm dark:!text-white"
                  }
                >
                  {reportFeaturesT(
                    commentReportingOptions?.find(
                      (option) => option?.isSelected
                    )?.subtext
                  )}
                </Span>
              </div>
              <div className="w-full flex flex-col gap-2 p-4">
                <div className="w-full flex items-center justify-between">
                  <Span
                    className={
                      "!font-medium !text-sm !leading-4 !text-[#3339] dark:!text-white"
                    }
                  >
                    {reportFeaturesT("report_description")}
                  </Span>
                  <Span
                    className={
                      "!font-light !text-sm !leading-4 !text-[#3339] dark:!text-white"
                    }
                  >
                    {notesReportForm?.reportDescription?.length}/200
                  </Span>
                </div>
                <textarea
                  className="w-full p-2 rounded resize-none bg-gray-100  dark:bg-brown placeholder:text-gray-300 dark:placeholder:text-neutral-600 hide-scrollbar outline-none ring-0 caret-red"
                  value={notesReportForm?.reportDescription}
                  placeholder={reportFeaturesT("report_desc_placeholder")}
                  rows={3}
                  onChange={(e) => {
                    if (notesReportForm?.reportDescription?.length <= 200) {
                      setNotesReportForm({
                        ...notesReportForm,
                        reportDescription: e.target.value,
                      });
                    }
                  }}
                />
              </div>
              <div className="w-full flex flex-col gap-2 p-4">
                <div className="w-full flex items-center justify-between mb-16">
                  <Span
                    className={
                      "!font-medium !text-sm !leading-4 !text-[#3339] dark:!text-white"
                    }
                  >
                    {reportFeaturesT("photo_evidence")}
                  </Span>
                  <Span
                    className={
                      "!font-light !text-sm !leading-4 !text-[#3339] dark:!text-white"
                    }
                  >
                    {notesReportForm?.reportNotesFiles?.length}/3
                  </Span>
                </div>
                <div className="w-full flex flex-col  gap-2">
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleFileChange}
                    id="file-upload"
                    name="file-upload"
                    hidden
                    disabled={notesReportForm?.reportNotesFiles?.length >= 3}
                  />
                  <div className="flex flex-wrap gap-4 items-center">
                    {notesReportForm.reportNotesFiles.map((file, index) => (
                      <div key={index} className="relative">
                        <img
                          src={URL.createObjectURL(file)}
                          alt={`preview-${index}`}
                          className="w-24 h-24 object-cover rounded-md"
                        />
                        <button
                          type="button"
                          className="absolute top-2 right-2 bg-red-500 bg-black bg-opacity-10 backdrop-blur text-white rounded-full p-1 text-xs"
                          onClick={() => removeFile(index)}
                        >
                          X
                        </button>
                      </div>
                    ))}
                    <label
                      htmlFor="file-upload"
                      className={`w-20 h-20 flex items-center justify-center text-xs p-2 rounded-md border border-gray-200 text-gray-600 ${notesReportForm?.reportNotesFiles?.length >= 3
                        ? "cursor-not-allowed"
                        : "cursor-pointer"
                        }`}
                    >
                      <span className="text-center dark:!text-white">
                        + {reportFeaturesT("upload")}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="w-full dark:bg-light_primary_label bg-dark_primary_label flex items-center justify-center py-3 border-t dark:border-neutral-500">
          <SolidButton
            onClick={() => {
              if (!isStepNext) setIsStepNext((prev) => !prev);
              else submitNotesReport();
            }}
            loading={submitBtnLoader}
          >
            {isStepNext
              ? reportFeaturesT("submit")
              : reportFeaturesT("next_step")}
          </SolidButton>
        </div>
      </div>
    </div>
  );
};

export default ContentReporter;
